import { FeatureListMap, SummaryPackageFeatureList } from '~pricing/transformers/summary/types';

/**
 * The factory class declares the factory method that is supposed to return an
 * object of a summary package list which is then fed to the summary transformer.
 * The subclasses usually provide the implementation of this method.
 */
export abstract class PlanTransformersFactory {
  /**
   * Note that the factory class may also provide some default implementation of the
   * factory method.
   */
  public initializeList(): SummaryPackageFeatureList {
    // Call the factory method to create a SummaryPackageFeatureList object.
    return this.createFeatureList();
  }

  /**
   * Also note that, despite its name, the factory's primary responsibility is
   * not creating summary list. Usually, it contains some core business logic that
   * relies on summary transformer objects, returned by the factory method. Subclasses can
   * indirectly change that business logic by overriding the factory method
   * and returning a different type of summary transformer from it.
   */
  public abstract createFeatureList(): SummaryPackageFeatureList;
}

/**
 * Extensions allowed, but it is easier to override the featureList with your own config
 */
export default class PlanTransformers extends PlanTransformersFactory {
  private _featureList: FeatureListMap;

  private readonly treatment: string;

  constructor(featureList: FeatureListMap, treatment: string) {
    super();
    this._featureList = featureList;
    this.treatment = treatment;
  }

  public get featureList(): FeatureListMap {
    return this._featureList;
  }

  public set featureList(value: FeatureListMap) {
    this._featureList = value;
  }

  /**
   * Use the treatment config mapping so any control assignment uses the default.
   * @returns SummaryPackageFeatureList
   */
  public createFeatureList(): SummaryPackageFeatureList {
    return this._featureList[this.treatment] ?? this.featureList?.default;
  }
}
